module.exports = __webpack_public_path__ + "img/15.cc72f4b3.png";